import React from 'react';
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';
import './index.scss';

import {api} from '../../../functions/api'

import CircularProgress from '@material-ui/core/CircularProgress';

import CustomTabs from '../../../components/basic/customTabs';

//TABS - MODULES
import ClientBasicInfo from './basic';
import ClientUsers from './users';
import ClientRepresentants from './representants';
import ClientOrders from './orders';
import ClientDocs from './docs';
import ClientBrenches from './branches';
import ClientInvisible from './invisible';

@inject('internal')
@inject('client')
@inject('translate')
@observer
export default class ClientDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    tabsConfig = [
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.BASIC_INFO,
        //     url: "/clients/detail/tab=0"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.USERS,
        //     url: "/clients/detail/tab=1"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.REPRESENTATIVES,
        //     url: "/clients/detail/tab=2"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.ORDERS,
        //     url: "/clients/detail/tab=3"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.DOCS,
        //     url: "/clients/detail/tab=4"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.BRANCHES,
        //     url: "/clients/detail/tab=5"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.CLIENTS.TABS.INVISIBLE,
        //     url: "/clients/detail/tab=6"
        // }
    ]

    componentDidMount() {
        this.loadClientDetail();
        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
    }


    loadClientDetail = async () => {

        let load_data = await api({
            method: 'get',
            url: 'clients/' + this.props.match.params.idClient,
            authorization: this.props.internal.user.access_token,
        })

        if (load_data.success && load_data.success === true) {
            this.props.client.setClientData(load_data.data.data);
            this.props.internal.setDataForSimpeTable(load_data.data.data)
            
            this.setPermissions()
        }
        this.setState({loading: false})
    }

    setPermissions () {
        this.tabsConfig = [
            {
                label: this.props.translate.i18n.MODULES.CLIENTS.TABS.BASIC_INFO,
                // url: "/clients/detail/tab=0"
                url: "/clients/basic"
            },
        ]
        let permissions = toJS(this.props.internal.user.data.permissions)
        if(permissions.clients_members && permissions.clients_members.view) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.USERS,
                    // url: "/clients/detail/tab=1"
                    url: "/clients/users"
                },
            )
        }

        if(permissions.clients_admins && permissions.clients_admins.view) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.REPRESENTATIVES,
                    // url: "/clients/detail/tab=2"
                    url: "/clients/oz"
                },
            )
        }

        if(permissions.clients_orders && permissions.clients_orders.view) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.ORDERS,
                    // url: "/clients/detail/tab=3"
                    url: "/clients/orders"
                },
            )
        }

        if(permissions.clients_documents && permissions.clients_documents.view) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.DOCS,
                    // url: "/clients/detail/tab=4"
                    url: "/clients/docs"
                },
            )
        }

        if(permissions.clients_branches && permissions.clients_branches.view) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.BRANCHES,
                    // url: "/clients/detail/tab=5"
                    url: "/clients/branches"
                },
            )
        }
        if(permissions.clients && permissions.clients.invisible) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.CLIENTS.TABS.INVISIBLE,
                    // url: "/clients/detail/tab=6"
                    url: "/clients/invisible"
                }
            )
        }
        // if(toJS(this.props.internal.user.data.role.id) <= 2) {
        //     this.tabsConfig.push(
        //         {
        //             label: this.props.translate.i18n.MODULES.CLIENTS.TABS.INVISIBLE,
        //             // url: "/clients/detail/tab=6"
        //             url: "/clients/invisible"
        //         }
        //     )
        // }
    }


    render() {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        return (
            
            <div className={'client-detail-container'}>
                {this.state.loading ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    <div className={'clients-details'}>
                        <CustomTabs
                            title={toJS(this.props.client.clientData.name)}
                            tabsConfig={this.tabsConfig }
                            routerData={routerData}
                            module={'/clients'}
                            >
                            

                            {this.state.loading ? null :
                                <ClientBasicInfo routerData={routerData}></ClientBasicInfo>
                            }
                            {this.state.loading ? null :
                                <ClientUsers routerData={routerData}></ClientUsers>
                            }
                            {this.state.loading ? null :
                                <ClientRepresentants routerData={routerData}></ClientRepresentants>
                            }
                            {this.state.loading ? null :
                                <ClientOrders routerData={routerData}></ClientOrders>
                            }
                            {this.state.loading ? null :
                                <ClientDocs routerData={routerData}></ClientDocs>
                            }
                            {this.state.loading ? null :
                                <ClientBrenches routerData={routerData}></ClientBrenches>
                            }
                            {this.state.loading ? null :
                                <ClientInvisible routerData={routerData}></ClientInvisible>
                            }
                        </CustomTabs>


                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/index.js